import { useMantineTheme } from "@mantine/core";
import { useMemo } from "react";
import { FieldValues, useFormContext, useWatch } from "react-hook-form";

import { RecommendedButtonGroupProps } from "#shared/view/designSystem/inputs/RecommendButtonGroup";
import { round } from "shared";

export const useRecommendedInputStyles = <T extends FieldValues>({
  companyValue,
  computedValue,
  name,
  precision,
}: RecommendedButtonGroupProps<T>) => {
  const theme = useMantineTheme();
  const { control } = useFormContext();
  const currentValue = useWatch({ control, name });

  const isRecommendedValue =
    (!!computedValue?.value &&
      round(currentValue, precision) === round(computedValue.value, precision)) ||
    (!!companyValue?.value &&
      round(currentValue, precision) === round(companyValue.value, precision));

  const inputStyles = useMemo(
    () => styles(isRecommendedValue ? theme.colors.blue[5] : theme.black),
    [isRecommendedValue, theme],
  );

  return inputStyles;
};

const styles = (color: string | undefined) => () => ({
  input: {
    color,
  },
});
